'use strict';

var base = require('base/product/base');
var buttonReference;
/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} response - response from server
 */
function createCarousel(imgs, $productContainer, response) {
    var carousel = $productContainer.find('.carousel.slide.inPdpResult');
    $(carousel).carousel('dispose');
    var carouselId = $(carousel).attr('id');

    const nuevoLanzamiento = response.product && response.product.nuevoLanzamiento;
    const promotionsTagsHTML = response.product && response.product.promotionsTagsHtml ? response.product.promotionsTagsHtml : '';
    let tagNuevoLanzamiento = '';
    const imageSource = $(".tag-nuevo").val();
    if (nuevoLanzamiento) {
        tagNuevoLanzamiento = `<img src="${imageSource}" class="nuevo-tag" alt="nuevo">`;
    }

    $(carousel).empty().append('<ol class="carousel-indicators"></ol>' + promotionsTagsHTML + tagNuevoLanzamiento + '<div class="carousel-inner" role="listbox"></div><a class="carousel-control-prev" href="#' + carouselId + '" role="button" data-slide="prev"><span class="fa icon-prev" aria-hidden="true"></span><span class="sr-only">' + $(carousel).data('prev') + '</span></a><a class="carousel-control-next" href="#' + carouselId + '" role="button" data-slide="next"><span class="fa icon-next" aria-hidden="true"></span><span class="sr-only">' + $(carousel).data('next') + '</span></a>');

    for (var i = 0; i < imgs.length; i++) {
        $('<div class="carousel-item"><img src="' + imgs[i].url + '" class="d-block img-fluid" alt="' + imgs[i].alt + ' image number ' + parseInt(imgs[i].index, 10) + '" title="' + imgs[i].title + '" itemprop="image" /></div>').appendTo($(carousel).find('.carousel-inner'));
        $('<li data-target="#' + carouselId + '" data-slide-to="' + i + '" class=""></li>').appendTo($(carousel).find('.carousel-indicators'));
    }
    $($(carousel).find('.carousel-item')).first().addClass('active');
    $($(carousel).find('.carousel-indicators > li')).first().addClass('active');
    if (imgs.length === 1) {
        $($(carousel).find('.carousel-indicators, a[class^="carousel-control-"]')).detach();
    }
    $(carousel).carousel();
    $($(carousel).find('.carousel-indicators')).attr('aria-hidden', true);

    var setInProductHtml = response && response.product && response.product.setInProductHtml;
    var renderSetInProduct = $(".renderSetInProduct");
    renderSetInProduct.empty().html(setInProductHtml);

    var wScreen = $(window).width();
    if (wScreen < 1200 && !$(".product-recommended-mobile").hasClass("active")) {
        var renderSetInProductMobile = $(".renderSetInProductMobile");
        renderSetInProductMobile.empty().html(setInProductHtml);
    }
    if (wScreen >= 1200 && !$(".product-recommended-desktop").hasClass("active")) {
        var renderSetInProductDesktop = $(".renderSetInProductDesktop");
        renderSetInProductDesktop.empty().html(setInProductHtml);
    }

    var variationModalHTML = response && response.product && response.product.variationModalHTML;
    var renderModal = $(".carouselImagesPDP");
    renderModal.empty().html(variationModalHTML);

    // $("#carousel-images-modal").find('.inPdpResult').find(".carousel-control-next").click();

    // Destruir la instancia anterior del carrusel
    $('.inPdpResult').carousel('dispose');

    // Reinicializar el carrusel
    $('.inPdpResult').carousel({
        interval: false, // Intervalo de tiempo, puedes cambiarlo según lo necesites
        ride: 'carousel'
    });

    // actualizacion de contador de total de imagenes en carrusel
    var detail = require('./detail');
    detail.spCarouselModalMovil();
}

/**
* Gets the alternative variation for the product.
* @param {string} url - URL to get the alternative variation
* @param {jQuery} $swatchButton - DOM element for the swatch button
*/
function getAlternativeVariation(url, $swatchButton) {
    $.ajax({
        url: url,
        method: 'GET',
        success: function (data) {
            if (data && data.url) {
                $swatchButton.attr('data-url', data.url);
            }
            return null;
        }
    });
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="'
            + attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.isSelectable) {
            $swatchButton.removeClass('d-none');
            $swatchButton.prop('disabled', false);
        } else {
            $swatchButton.addClass('d-none');
            $swatchButton.prop('disabled', true);
        }

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').addClass("selected");
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').removeClass("selected");
        }

        var isFormatAttr = attr.id === 'formato';
        var isColorAttr = attr.id === 'color';
        var url;
        var includeFormat = attrValue.url && attrValue.url.includes('format') && attrValue.url.split('=')[1].length > 0;
        var masterPid = $productContainer.attr("data-pid");
        var urlGetAlternativeVariation = $productContainer.data('varitions-url');
        var selectable = attrValue.selectable;
        if (attrValue.url) {
            // we need always one format in the url 
            if (isColorAttr && !includeFormat) {
                url = urlGetAlternativeVariation + '?pid=' + masterPid + '&attribute='+ attr.id + '&value=' + attrValue.value;
                selectable = false;
                getAlternativeVariation(url, $swatchButton);
                
            } else {
                $swatchButton.attr('data-url', attrValue.url);
            }
        } else {
            // we need to get the url from the server if the url is not present in the response
            if (isFormatAttr) {
                selectable = false;
                url = urlGetAlternativeVariation + '?pid=' + masterPid + '&attribute='+ attr.id + '&value=' + attrValue.value;
                getAlternativeVariation(url, $swatchButton) 
            }
            if (isColorAttr && !includeFormat) {
                selectable = false;
                url = urlGetAlternativeVariation + '?pid=' + masterPid + '&attribute='+ attr.id + '&value=' + attrValue.value;
                getAlternativeVariation(url, $swatchButton) 
            }            
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass('selectable');
        if (!attrValue.selectable) {
            $attrValue.addClass('unable');
            $attrValue.siblings('.selected-assistive-text').addClass("unable");
        } else {
            $attrValue.removeClass('unable');
            $attrValue.siblings('.selected-assistive-text').removeClass("unable");
        }
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color', 'formato'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }

        if ($('.desc-prev-item')) {
            $('.desc-prev-item').each( function () {
                $(this).remove();
            })
        }

        response.product.descargables[0].prev.sort((a, b) => {
            return b.name.localeCompare(a.name);
        });

        for (let i = 0; i < response.product.descargables[0].prev.length; i++) {
            let tagaprev = `<a class="dropdown-item descargable-item desc-prev-item" href="${response.product.descargables[0].prev[i].value}" target="_blank" rel="noopener noreferrer">${response.product.descargables[0].prev[i].name}</a>`;
            $('.dropdown-menu-descargables').prepend(tagaprev)
        }

        if ($('.desc-directo-item-next')) {
            $('.desc-directo-item-next').each( function () {
                $(this).remove();
            })
        }

        response.product.descargables[0].directo.sort((a, b) => {
            return b.name.localeCompare(a.name);
        });

        for (let i = 0; i < response.product.descargables[0].directo.length; i++) {
            let tagdir = `<a class="dropdown-item descargable-item desc-directo-item-next" href="${response.product.descargables[0].directo[i].value}">${response.product.descargables[0].directo[i].name}</a>`;
            $('.dropdown-menu-descargables>.dropdown-divider').after(tagdir)
        }

        if ($('.input-descargable-img')) {
            $('.input-descargable-img').each( function () {
                $(this).remove();
            })
        }
        for (let i = 0; i < response.product.images.large.length; i++) {
            let taginputimg = `<input type="hidden" name="urls" class="input-descargable-img" value="${response.product.images.large[i].urlOriginal}" />`;
            $('.product-detail').prepend(taginputimg)
        }
    }

    // Update primary images
    var primaryImageUrls = response.product.images.large;
    createCarousel(primaryImageUrls, $productContainer, response);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    var wScreen = $(window).width();
    var explicitRecommendationsHTML = response.product.explicitRecommendationsHTML;
    if (explicitRecommendationsHTML && (wScreen >= 1200 && !$(".product-recommended-desktop").hasClass("active"))) {
        $productContainer.find('.renderSetInProductDesktop').children().last().after(response.product.explicitRecommendationsHTML);
    }

    // Update social icons info
    $(".share-button").find('.tooltip-top').empty().html(response.product.socialIconslHTML);
  
    if (explicitRecommendationsHTML && (wScreen < 1200 && !$(".product-recommended-mobile").hasClass("active"))) {
        $productContainer.find('.renderSetInProductMobile').children().last().after(response.product.explicitRecommendationsHTML);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
    var $wishlistHeart = $productContainer.find(".add-to-wish-list i");
    setTimeout(function() {
        if (response.isPrdInWishlist) {
            $wishlistHeart.removeClass('fa-heart-o').addClass('heart-white fa-heart');
        } else {
            $wishlistHeart.removeClass('heart-white fa-heart').addClass('fa-heart-o wishlist-icon');
        }
    }, 300);
}

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $('.quantity-select');
    }
    return quantitySelected;
}

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"'
                + selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}


/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        let pdpProductId = $(".product-wrapper").attr("data-pid");
        let url = selectedValueUrl;
        if (pdpProductId && pdpProductId.length) {
            url = selectedValueUrl + "&pdpProductId=" + pdpProductId;
        }
        $('body').trigger(
            'product:beforeAttributeSelect',
            { url: url, container: $productContainer }
        );

        $.ajax({
            url: url,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                // updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger(
                    'product:afterAttributeSelect',
                    { data: data, container: $productContainer }
                );
                $.spinner().stop();
                var variationAttributes = data.product.variationAttributes;
                const formatoItem = variationAttributes.find(element => element.attributeId === "formato");
                const colorItem = variationAttributes.find(element => element.attributeId === "color");
                const formatoDisplayName = formatoItem ? formatoItem.displayValue : null;
                const colorDisplayName = colorItem ? colorItem.displayValue : null;

                var factorMermaxCorte = data.product.factorMermaxCorte;
                $("#factorMermaxCorte").val(factorMermaxCorte);
                $("#formatSelected").val(formatoDisplayName);
                $("#colorSelected").val(colorDisplayName);

                var renderUsosSugeridos = $(".render-usos-sugeridos");
                renderUsosSugeridos.empty().html(data.product.usosSugeridosHTML);

                // update variation information
                $(".product-name").empty().html(data.product.productName);
                $("#collapsible-description").empty().html(data.product.shortDescription);

                // update product descargables
                $(".descargables-section").empty().html(data.product.descargablesHTML);
                var acabado = variationAttributes[2];
                if (acabado) {
                    var optionsSelector = $(".variation-attribute").find("select");
                    acabado.values.forEach(element => {
                        var isSelectable = element.selectable;
                        if (!isSelectable) {
                            optionsSelector.find("option").each(function () {
                                if ($(this).attr("data-attr-value") === element.value) {
                                    $(this).attr("disabled", "disabled");
                                }
                            });
                            
                        }
                    });
                    var acabadoSelected = acabado.values.find(element => element.selected);
                    if (acabadoSelected) {
                        optionsSelector.children("[selected]").removeAttr("selected");
                        optionsSelector.find("option").each(function () {
                            if ($(this).attr("data-attr-value") === acabadoSelected.value) {
                                $(this).attr("selected", "selected");
                            }
                        });
                        
                    }
                }          
                var metaDel = document.querySelector('meta[name="robots"]');
                if (metaDel) {
                    metaDel.parentNode.removeChild(metaDel);
                }
                var metaCre = document.createElement('meta');
                metaCre.name = "robots";
                metaCre.content = "noindex,nofollow";
                document.getElementsByTagName('head')[0].appendChild(metaCre);
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    if (response.customWarning) {
        messageType = response.customWarning;
        response.message = response.customMessage;
    }
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        $('.add-to-cart-messages').html('');
        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
            + response.message
            + '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 * calculate shrinkage when adding product to cart
 *
 * @param {number} factorMermaxCorte - a value that indicates the porcentage of the product to be factored
 * @param {number} metrosCaja - number of meters to add to cart
 * @param {number} cajas - number of boxes to add to cart
 * @param {number} metrosCajaDn - metrosCajaDn added in product
 * @param {number} format - format selected in variation
 * @param {number} color - color selected in variation
 * @param {string} productName - productName selected in variation
 */
function calculoMerma(factorMermaxCorte, metrosCaja, cajas, metrosCajaDn, format, color, productName) {
    var metros= parseFloat(metrosCaja);
    var merma = (factorMermaxCorte * metros);
    var totalAdicional = merma + metros;
    var cantidadCajas = Math.ceil(totalAdicional.toFixed(2) / metrosCajaDn);
    var cantidadCajaAdicional = Math.ceil(merma.toFixed(2) / metrosCajaDn);
    // Get available stock of product
    var pid = getPidValue($(buttonReference));
    var cantidadDis = $(".availability-product-" + pid);
    var availableStock = Number(cantidadDis.val());

    if(cantidadCajas > cajas && availableStock >= cantidadCajas) {
        $('#mermaModal').modal('show');
        var mermaRecomendation = $('#merma-recomendacion');
        var metrosCajas =$("#metros-cajas");
        var adicionalCortes =$("#adicional-cortes");
        var totalMerma =$(".total-merma");
        var formatVariation = $("#format-selected");
        var colorVariation =$("#color-selected");
        var nameOfProduct= $("#product-name");
        mermaRecomendation.empty();
        metrosCajas.empty();
        adicionalCortes.empty();
        totalMerma.empty();
        formatVariation.empty();

        var productNameSelected = `
        <p class="info-result ${productName != "null" ? '' : 'd-none'}" id="product-name"> ${productName || ''}</p>
        `;

        var formatSelected = `
        <p class="info-result ${format != "null" ? '' : 'd-none'}" id="format-selected">Formato: ${format || ''}</p>
        `;

        var colorSelected = `
        <p class="info-result ${color != "null" ? '' : 'd-none'}" id="color-selected">Color: ${color || ''}</p>
        `;
        
        var mermaVal = `
        <p class="info-result" id="merma-recomendacion">${factorMermaxCorte*100}%</p>
        `;

        var resultMC = `
        <p class="info-result" id="metros-caja">${metrosCaja} m<sup>2</sup> /${cajas} ${cajas > 1 ? 'cajas' : 'caja'}</p>
        `;

        var adicional = `
        <p class="info-result" id="adicional-cortes">${merma.toFixed(2)} m<sup>2</sup> /${cantidadCajaAdicional} ${cantidadCajaAdicional  > 1 ? 'cajas' : 'caja'}</p>
        `;

        var total = `
        <p class="total-merma">${totalAdicional.toFixed(2)} m<sup>2</sup> / ${cantidadCajas} ${cantidadCajas > 1 ? 'cajas' : 'caja'}</p>
        `;
        $(buttonReference).data("total-merma", cantidadCajas);
        mermaRecomendation.append(mermaVal);
        metrosCajas.append(resultMC);
        adicionalCortes.append(adicional);
        totalMerma.append(total);
        nameOfProduct.html(productNameSelected)
        formatVariation.html(formatSelected);
        colorVariation.html(colorSelected);
    } else {
        $('button.js-add-no-merma').trigger('click');
    }
}

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            base.chooseBonusProducts(data)
        }
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal,

    onClosingChooseBonusProductModal: base.onClosingChooseBonusProductModal,

    trapChooseBonusProductModalFocus: base.trapChooseBonusProductModalFocus,

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button, [data-attr="formato"] button', function (e) {
            e.preventDefault();
            if ($(this).find('.selected-assistive-text').hasClass('selected')) {
                return;
            }
            if ($(this).attr('data-url') != "null") {
                $(".js-calculator").data("set-update", "true");

                if ($(this).attr('disabled')) {
                    return;
                }
                var $productContainer = $(this).closest('.set-item');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.product-detail');
                }

                attributeSelect($(this).attr('data-url'), $productContainer);
            }
        });
    },

    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();

            $(".js-calculator").data("set-update", "true");
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            attributeSelect(e.currentTarget.value, $productContainer);
        });
    },

    availability: base.availability,

    addToCart: function () {
        $(document).on('click', 'button.add-to-cart', function () {
            var factorMermaxCorte = $(this).closest('.product-detail').find("#factorMermaxCorte").val();
            var metrosCaja = $(this).closest('.product-detail').find("#metrosCaja").val();
            var cajas = $(this).closest('.product-detail').find("#CantidadProd").val();
            var metrosCajaDn = $(this).closest('.product-detail').find(".metrosCajaDn").val();
            var format = $(this).closest('.product-detail').find("#formatSelected").val();
            var color = $(this).closest('.product-detail').find("#colorSelected").val();
            var productName = $(this).closest('.product-detail').find(".product-name").first().text();
            buttonReference = this;
            if (factorMermaxCorte !== null && factorMermaxCorte !== '' && metrosCaja !== null  && metrosCaja !== '') {
                calculoMerma(factorMermaxCorte, metrosCaja, cajas, metrosCajaDn, format, color, productName);
            } else {
                $('button.js-add-no-merma').trigger('click');
            }
            $.spinner().stop();
        });

        $(document).on('click', 'button.add-to-cart-global', function () {
            buttonReference = this;
            $('button.js-add-no-merma').trigger('click');
        });

        $(document).on('click', 'button.js-add-merma, button.js-add-no-merma', function () {
            var isModalMerma= false;
            if ($('#mermaModal').hasClass('show')) {
                isModalMerma = true;
                $('#mermaModal').modal('hide');
            }
           
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var isMerma = $(this).hasClass('js-add-merma');
            let isMermaAjax = $(this).hasClass('js-add-merma');

            $('body').trigger('product:beforeAddToCart', buttonReference);

            if ($('.set-items').length && $(buttonReference).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        let maxQty = $(this).find('input.cantidadDis').val();
                        setPids.push({
                            pid: $(this).find('.product-id').text(),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this)),
                            maxQty: maxQty && maxQty !== 'null' && maxQty !== 'false' ? maxQty : 0
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(buttonReference));

            var $productContainer = $(buttonReference).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(buttonReference).closest('.quick-view-dialog').find('.product-detail');
            }

            addToCartUrl = getAddToCartUrl();
            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: isMerma ? $(buttonReference).data("total-merma") : getQuantitySelected($(buttonReference))
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(buttonReference).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        if (data.searchImpressionData) {
                            var newValuesMerma = JSON.parse(data.searchImpressionData);
                            var isMermaVal= isMermaAjax ? 'Yes' : 'No';
                            if(isModalMerma) {
                                newValuesMerma.event = 'view_advice';
                                newValuesMerma.accepts_advice = isMermaVal;
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({ecommerce: null});
                                window.dataLayer.push(newValuesMerma);
                            }
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({ecommerce: null});
                            window.dataLayer.push(JSON.parse(data.searchImpressionData));
                        }
                        handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', data);
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },

    selectBonusProduct: base.selectBonusProduct,
    removeBonusProduct: base.removeBonusProduct,
    enableBonusProductSelection: base.enableBonusProductSelection,
    showMoreBonusProducts: base.showMoreBonusProducts,
    addBonusProductsToCart: base.addBonusProductsToCart,
};
